import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import CategoryService from '../../../Services/QRCodeServices/MenuCategory/CategoryService';

export const MenuCategoryDropdown = ({ value, onChange }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch categories on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const data = await CategoryService.getList();
        // Transform data into the format required by react-select
        const options = data.map((category) => ({
          value: category.id,
          label: category.name,
        }));
        setCategories(options);
      } catch (err) {
        setError('Failed to fetch menu categories');
        console.error('Error fetching categories:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // Handle change event
  const handleChange = (selectedOptions) => {
    // Pass the selected values back to the parent component
    onChange(selectedOptions);
  };

  if (loading) {
    return <Select isDisabled placeholder="Loading categories..." />;
  }

  if (error) {
    return <Select isDisabled placeholder="Error loading categories" />;
  }

  return (
    <Select
      isMulti // Enable multi-select
      isClearable // Enable clearable options
      isSearchable // Enable searchable filtering
      options={categories} // Pass the categories as options
      value={value} // Controlled value
      onChange={handleChange} // Handle change event
      placeholder="Select Category"
    />
  );
};